import React from 'react';
import { SubscriptionStatus } from '../../types/subscription';

interface Props {
  status: SubscriptionStatus;
  className?: string;
}

const STATUS_CONFIG: Record<SubscriptionStatus, { label: string; className: string }> = {
  ACTIVE:    { label: 'Active',    className: 'bg-green-100 text-green-800' },
  EXPIRED:   { label: 'Expired',   className: 'bg-red-100 text-red-800' },
  CANCELLED: { label: 'Cancelled', className: 'bg-gray-100 text-gray-600' },
  PAUSED:    { label: 'Paused',    className: 'bg-blue-100 text-blue-800' },
};

export const SubscriptionBadge: React.FC<Props> = ({ status, className = '' }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.EXPIRED;
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className} ${className}`}>
      {config.label}
    </span>
  );
};
